var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.708 22.105C45.297 21.543 35.505 8.341 23 8.341 10.494 8.34.702 21.543.292 22.105a1.518 1.518 0 0 0 0 1.79C.702 24.457 10.494 37.66 23 37.66c12.505 0 22.297-13.203 22.708-13.765.39-.533.39-1.257 0-1.79ZM23 35.628c-9.212 0-17.932-9.762-20.294-12.627C5.065 20.134 13.768 10.373 23 10.373c9.21 0 18.382 9.762 20.745 12.628C41.386 25.868 32.231 35.628 23 35.628Z",
    fill: "#1C2451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.901c-5.017 0-9.1 4.082-9.1 9.1 0 5.016 4.083 9.098 9.1 9.098 5.017 0 9.099-4.082 9.099-9.099s-4.082-9.099-9.1-9.099Zm0 15.864c-3.345 0-6.765-3.42-6.765-6.765 0-3.345 3.42-6.764 6.765-6.764 3.345 0 6.765 3.42 6.765 6.764 0 3.345-3.42 6.765-6.765 6.765Z",
    fill: "#1C2451"
  })));
};
export default SvgAttention;